var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M63.563 33.077c2.25 1.3 2.25 4.547 0 5.846L19.688 64.254c-2.25 1.3-5.063-.325-5.063-2.923V10.67c0-2.598 2.813-4.222 5.063-2.923z"
  })));
};
export default SvgPlay;